import gql from "graphql-tag";

export const {
  insertRole,
  insertUser,
  insertNews,
  editRole,
  editUser,
  editNews,
} = {
  insertRole: gql`
    mutation insertRole($roleName: String!) {
      insertRole(roleName: $roleName) {
        success
        data {
          id
          roleName
          createdAt
        }
        msg
      }
    }
  `,
  insertUser: gql`
    mutation insertUser($userObj: UserInput!) {
      insertUser(userObj: $userObj) {
        success
        data {
          id
          userName
          createdAt
          isActive
          role {
            id
            roleName
          }
          fullName
          email
        }
        msg
      }
    }
  `,
  insertNews: gql`
    mutation insertNews($newsObj: NewsInput!) {
      insertNews(newsObj: $newsObj) {
        success
        data {
          id
          title
          content
          createdAt
          updatedAt
          isDeleted
          author {
            id
            userName
          }
          image
        }
        msg
      }
    }
  `,
  editRole: gql`
    mutation editRole($roleObj: RoleInputEdit) {
      editRole(roleObj: $roleObj) {
        success
        affectedRows
        msg
      }
    }
  `,
  editUser: gql`
    mutation editUser($userObj: UserInputEdit) {
      editUser(userObj: $userObj) {
        success
        affectedRows
        msg
      }
    }
  `,
  editNews: gql`
    mutation editNews($newsObj: NewsInputEdit) {
      editNews(newsObj: $newsObj) {
        success
        affectedRows
        msg
      }
    }
  `,
};
